import { Controller } from '@hotwired/stimulus'
import consumer from '~/channels/consumer'

export default class extends Controller {
  static targets = ['list', 'activeCount']

  static values = {
    refreshInterval: { type: Number, default: 30000 }
  }

  connect() {
    this.subscribeToChannel()
    this.startAutoRefresh()
  }

  disconnect() {
    this.unsubscribeFromChannel()
    this.stopAutoRefresh()
  }

  subscribeToChannel() {
    this.subscription = consumer.subscriptions.create(
      { channel: 'AdminSupportChannel' },
      {
        received: (data) => this.handleChannelMessage(data)
      }
    )
  }

  unsubscribeFromChannel() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleChannelMessage(data) {
    switch (data.event) {
      case 'new_chat_session':
        this.handleNewSession(data.session)
        break
      case 'chat_session_ended':
        this.handleSessionEnded(data.session_id)
        break
      case 'chat_message':
      case 'new_chat_message':
        this.handleNewMessage(data.session_id)
        break
    }
  }

  handleNewSession(session) {
    this.showNotification(`New chat from ${session.user_name}`, 'info')
    this.refresh()
  }

  handleSessionEnded(_sessionId) {
    this.refresh()
  }

  handleNewMessage(_sessionId) {
    this.updateWaitTimes()
  }

  startAutoRefresh() {
    this.refreshTimer = setInterval(() => {
      this.updateWaitTimes()
    }, this.refreshIntervalValue)
  }

  stopAutoRefresh() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  updateWaitTimes() {
    const waitTimeElements = this.element.querySelectorAll('[data-started-at]')

    waitTimeElements.forEach((el) => {
      const startedAt = new Date(el.dataset.startedAt)
      const now = new Date()
      const seconds = Math.floor((now - startedAt) / 1000)

      el.textContent = this.formatWaitTime(seconds)

      const row = el.closest('tr')
      if (row) {
        if (seconds > 120) {
          row.classList.add('bg-amber-50')
          el.classList.add('text-red-600', 'font-bold')
        } else {
          row.classList.remove('bg-amber-50')
          el.classList.remove('text-red-600', 'font-bold')
        }
      }
    })
  }

  formatWaitTime(seconds) {
    if (seconds < 60) {
      return `${seconds}s`
    } if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${minutes}m ${secs}s`
    }
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    return `${hours}h ${minutes}m`
  }

  refresh() {
    window.location.reload()
  }

  showNotification(message, type = 'info') {
    const colors = {
      info: 'bg-blue-50 border-blue-500 text-blue-700',
      success: 'bg-green-50 border-green-500 text-green-700',
      error: 'bg-red-50 border-red-500 text-red-700'
    }

    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 z-50 p-4 rounded border-2 ${colors[type] || colors.info}`
    notification.textContent = message

    document.body.appendChild(notification)

    setTimeout(() => {
      notification.remove()
    }, 5000)
  }
}
